<template>
  <div class="page-container">
    <el-form
      :inline="true"
      class="demo-form-inline toolbar"
      style="padding-bottom: 0px"
    >
      <el-form-item>
        <kt-button
          type="warning"
          icon="el-icon-back"
          label="返回"
          @click="goBack()"
        />
      </el-form-item>
    </el-form>
    <div class="content" v-loading="loading" element-loading-text="拼命加载中">
      <volunteer-common :dataInfo="dataInfo"></volunteer-common>
    </div>
  </div>
</template>
<script>
import KtButton from "@/components/KtButton";
import volunteerCommon from "@/components/volunteer-common";
import util from "@/utils/util.js";
export default {
  components: { KtButton, volunteerCommon },
  data() {
    return {
      loading: true,
      userId: "", //userId
      avatar: "", //拼接的图片路径
      //传给子组件的值
      dataInfo: {
        volunteer: {},
        recipients: {
          name: "xxxxx",
          idCard: "420121193010248888",
          age: "88",
          phone: "13283834545",
          sex: "男",
          contactAddress: "光谷软件园A-11栋",
          regionalCommunity: "洪山社区",
          area: "武汉江夏区",
        },
      },
    };
  },
  methods: {
    goBack() {
      console.log("返回上层");
      bus.$emit('close_current_tags');
    },
    personalDetail() {
      let userId = this.userId;
      console.log(userId);
      this.$postForm("uac/volunteer/getById/" + userId).then((res) => {
        console.log(res);
        var info = res.result;
        console.log(info);
        info.sex == 0 ? (info.sex = "女") : (info.sex = "男");
        info.serviceTimes
          ? (info.serviceTimes = util.formatDate.format(
              new Date(info.serviceTimes),
              "yyyy-MM-dd hh:mm:ss"
            ))
          : (info.serviceTimes = "");
        info.headerPic = this.avatar;
        this.dataInfo.volunteer = info;
        setTimeout(() => {
          this.loading = false;
        }, 500);
      });
    },
    //图片的回显
    getImgInfo(headerPicId) {
      let id = headerPicId;
      console.log(id);
      if (id) {
        this.$postForm("opc/file/queryAttachmentById/" + id).then((res) => {
          console.log(res);
          var path = res.result.path;
          var name = res.result.name;
          this.avatar = "http://51cs8.com/" + path + name;
        });
      }
    },
  },
  created() {
    var headerPicId = this.$route.query.headerPic;
    console.log(headerPicId);
    if (headerPicId && headerPicId != 0) {
      this.getImgInfo(headerPicId);
    }
  },
  mounted() {
    setTimeout(() => {
      this.userId = this.$route.query.userId;
      console.log(this.userId);
      this.personalDetail();
    }, 500);
  },
};
</script>
<style lang="scss" scoped>
.page-container {
  height: 500px;
  display: flex;
  flex-direction: column;
  background: #fff;
  .demo-form-inline {
    height: 60px;
  }
  .content {
    width: 99%;
    flex: 1;
  }
}
</style>
